import * as React from "react";
import { connect } from "react-redux";
import { GlobalState } from "../../../store";
import { User, Activity } from "../../../api/classes";
import { Avatar, Typography, Divider, Card } from "@material-ui/core";
import * as moment from "moment";
import ActivityIcon from "@material-ui/icons/Timeline";
import MoreSettings from "src/components/more";
import ApproveDialog from "src/components/dialogs/approveDialog";
import { DEFAULT_AVATAR } from "src/auth/auth";
import { Link } from "react-router-dom";

interface Props {
  user: User;
  activity: Activity;
  card?: boolean;
  style?: React.CSSProperties;
  onDelete?: (activity: Activity) => void;
}
class CaseActivity extends React.Component<Props> {
  state = {
    deleteOpen: false
  };
  render() {
    if (this.props.card) {
      return (
        <Card
          style={{
            ...this.props.style,
            display: "flex",
            flexDirection: "column",
            marginTop: 16,
            padding: 16,
            marginBottom: 16
          }}
        >
          <div style={{ paddingBottom: 4 }}>
            <div style={{ display: "flex", paddingBottom: 4 }}>
              <Avatar
                style={{
                  backgroundColor: "#41B442",
                  width: 20,
                  height: 20
                }}
              >
                <ActivityIcon />
              </Avatar>
              <Typography style={{ marginLeft: 12, marginBottom: 4 }}>
                Activity
              </Typography>
            </div>
            <Divider />
          </div>
          {this.renderInside()}
        </Card>
      );
    } else {
      return <div>{this.renderInside()}</div>;
    }
  }
  onDelete = () => {
    this.props.onDelete(this.props.activity);
  };
  renderInside() {
    const { user, activity } = this.props;
    if (!this.props.user) {
      return null;
    }
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          marginTop: 16,
          marginBottom: 16
        }}
      >
        <Avatar
          style={{ width: 32, height: 32 }}
          src={
            user && user.account_picture ? user.account_picture : DEFAULT_AVATAR
          }
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center"
            }}
          >
            <Link to={"/profile/" + user.id}>
              <Typography style={{ marginLeft: 8 }} variant="body2">
                {user && user.name}
              </Typography>
            </Link>
            <Typography style={{ marginLeft: 8 }} variant="caption">
              {moment(activity.created_at).format("LLL")}
            </Typography>
          </div>
          <Typography style={{ marginLeft: 8, fontSize: 13 }} variant="body1">
            {activity.text}
          </Typography>
        </div>
        {this.props.onDelete && (
          <>
            <MoreSettings
              options={[
                {
                  label: "Delete",
                  onClick: () => {
                    this.setState({ deleteOpen: true });
                  }
                }
              ]}
            />
            <ApproveDialog
              open={this.state.deleteOpen}
              title="Delete Activity"
              description={
                <>
                  Do you want to delete
                  <b>{" " + this.props.activity.text + " "}</b>
                  message by
                  <b>{" " + (this.props.user && this.props.user.name) + " "}</b>
                  from this case?
                </>
              }
              onApprove={this.onDelete}
            />
          </>
        )}
      </div>
    );
  }
}
function mapStateToProps(state: GlobalState, own: Props) {
  return {
    user:
      state.cases.users &&
      state.cases.users.find(u => u.id === own.activity.user_id)
  };
}
function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CaseActivity);



// WEBPACK FOOTER //
// ./src/pages/cases/components/activity.tsx